import React from "react";
import { Applications } from "@store/types";
import { State, getApplications } from "@store";
import { useSelector, useDispatch } from "react-redux";

export function useApplications(): {
  error: Error | null;
  fetching: boolean;
  value: Applications;
} {
  const dispatch = useDispatch();
  const [applications, error, fetching] = useSelector((state: State) => [
    state.applications,
    state.network.error.applications,
    state.network.fetching.applications,
  ]);

  React.useEffect(() => {
    if (!applications && !error && !fetching) {
      dispatch(getApplications());
    }
  }, [dispatch, applications, error, fetching]);

  return {
    error,
    fetching,
    value: applications,
  };
}
